export default __webpack_public_path__ + "static/media/sensotrend_connect_select_devices.631bbeb0.png";